import { axiosHelper } from 'Services/AxiosHelper';
import { BaseModel } from 'Models';
import { onDeleteCustomerCardByClosedBodyData } from 'Config';
import { getApiGWTokenCookie } from 'Utils';

const command = 'RI.OnDeleteCustomerCardByClosed';

const onDeleteCustomerCardByClosed = async (params: onDeleteCustomerCardByClosedBodyData): Promise<BaseModel> =>
  (
    await axiosHelper({
      method: 'post',
      gatewayData: {
        command,
        token: getApiGWTokenCookie(),
      },
      data: params,
    })
  ).data;

export default onDeleteCustomerCardByClosed;
